var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMobileStep3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 12,
    fill: "#F3F6F8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.6157 26.16C18.869 26.16 18.1917 26.0267 17.5837 25.76C16.9864 25.4827 16.4797 25.0827 16.0637 24.56L17.3117 23.312C17.5357 23.6533 17.8504 23.9253 18.2557 24.128C18.661 24.3307 19.1037 24.432 19.5837 24.432C20.0424 24.432 20.437 24.3467 20.7677 24.176C21.0984 24.0053 21.3544 23.7653 21.5357 23.456C21.7277 23.1467 21.8237 22.7893 21.8237 22.384C21.8237 21.9573 21.7277 21.5947 21.5357 21.296C21.3544 20.9973 21.0877 20.768 20.7357 20.608C20.3944 20.4373 19.9784 20.352 19.4877 20.352C19.2957 20.352 19.0984 20.368 18.8957 20.4C18.693 20.4213 18.5117 20.4587 18.3517 20.512L19.1677 19.456C19.3917 19.3707 19.6264 19.3013 19.8717 19.248C20.1277 19.184 20.373 19.152 20.6077 19.152C21.1837 19.152 21.701 19.2907 22.1597 19.568C22.629 19.8453 22.997 20.2347 23.2637 20.736C23.541 21.2267 23.6797 21.808 23.6797 22.48C23.6797 23.2053 23.509 23.8453 23.1677 24.4C22.8264 24.9547 22.3517 25.3867 21.7437 25.696C21.1357 26.0053 20.4264 26.16 19.6157 26.16ZM18.3517 20.512V19.424L21.3437 15.936L23.5517 15.888L20.4317 19.472L18.3517 20.512ZM16.6237 16.448V14.8H23.5517V15.888L21.9677 16.448H16.6237Z",
    fill: "#008CB7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobileStep3);
export default __webpack_public_path__ + "static/media/mobile-step3.404ca61da6557b4b971f244c56e8cec3.svg";
export { ForwardRef as ReactComponent };